import { UserRole } from "tm-shared/types";

import { logoutService } from "@/Services/Logout";
import { RootState } from "@/store";

export const selectProtectedUserRole = (state: RootState): UserRole => {
    if (!state.user.role) {
        logoutService();

        // throw new Error("User role is required in protected area");
    }

    return state.user.role as UserRole;
};
